/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.news_grp_news", {
        options: {
            slickOptions:{
                arrows: false,
                autoplay: true,
                autoplaySpeed: 6000,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                rows: 0,
                fade: true,
                cssEase: 'ease',
                pauseOnFocus: false, 
                pauseOnHover: false
            }
        },

        _create: function () {
            this.wrap = this.element;
            
            this.wrap.each((indx, el)=>{
                
                $(el).on('init', (slick)=>{
                    var dots = $('.slick-dots', $(slick.target))  
                    api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed/1000)
                })
                .slick(this.options.slickOptions)
                .on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
                    var dots = $('.slick-dots', $(event.target))
                    api.fn.slickDotsFilled(dots, nextSlide)
                })
            });

        }

    });
})(jQuery);
